import React, { useEffect, useState, useContext } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import useToken from "../../hooks/useToken";
import { DataContext, DataProvier } from "./data/DataContext";
import { IconProgressBar, LineProgressBar, ControlButton } from './components/controls';
import Pages from "./components/pages/Pages";
import { IconNext } from "./svg/index";
import { InitPage } from "./data/Data";
import { buildPoliza } from './services/help';
import { endPoints } from '../../utils/constanst';
import http from '../../services/http';
import Modal from "react-modal";


import "./VivirSeguro.css";

const VivirSeguro = () => {

    const { loading } = useToken();

    useEffect(() => {
        setTimeout(() => {
            const preloader = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event) => {
                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }
        }, 600);
    }, []);



    // FIN START #72556

    return (
        <DataProvier loading={loading}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/vivirseguro/" Redirect to="/micrositio/vivirseguro/" component={Layout} />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );
}

const Layout = ({ location }) => {
    const [index, setIndex] = useState(InitPage);
    const totalPages = 4;
    const { VivirSeguro, setVivirSeguro, changeHandler } = useContext(DataContext);
    const switchTypeIcon = [0, 0, 1, 2, 3, 3];

    const [show, setShow] = useState(false);
    const closeModalSave = () => setShow(false);
    const openModalSave = () => setShow(true);  

    const [msg, setMsg] = useState('');
    const [showMsg, setShowMsg] = useState(false);
    const closeModalMsg = () => setShowMsg(false);
    const openModalMsg = () => setShowMsg(true);  

    const textNext = (!VivirSeguro.esTelepago && index == 5) ? "¡Pagar ya!" : "Siguiente";
    //const textNext = (index == 3) ? "¡Pagar ya!" : "Siguiente";

    const decrement = () => {
        if (index !== 0) setIndex(index - 1);
    };
    const increment = () => {
        if (index <= totalPages) setIndex(index + 1);
    };

    const cssControlButton = (index) => {
        switch (index) {
            case 0: return "control-button-vivirseguro-only";
            case 5: return "display-none";
            default: return "";
        }
    }
    const handleSubmit = () => {
        let result = document.querySelector("form").reportValidity();

        if (index === 0 && result) {
            getSumaAsegurada();
            getFees();
            increment();
        }
        else if(validate() === false){
            openModalMsg();
        }
        else if(index ===4 && result)
            create();
        else  if (result) increment();
    }

    const validate = () => {
        let valid = true;
         if(index ===3)
         {
            if( VivirSeguro.esBeneficiario2 == false)
            {
                let p1 = (VivirSeguro.porcentajeBeneficio1 === null || VivirSeguro.porcentajeBeneficio1 === undefined  || VivirSeguro.porcentajeBeneficio1 === '') ? 0 : parseFloat(VivirSeguro.porcentajeBeneficio1);
                if(p1 !== 100){
                    valid = false;
                    setMsg('El porcentaje de beneficio debe ser el 100%');
                }
            }
            else{
                let p1 = (VivirSeguro.porcentajeBeneficio1 === null || VivirSeguro.porcentajeBeneficio1 === undefined  || VivirSeguro.porcentajeBeneficio1 === '') ? 0 : parseFloat(VivirSeguro.porcentajeBeneficio1);
                let p2 = (VivirSeguro.porcentajeBeneficio2 === null || VivirSeguro.porcentajeBeneficio2 === undefined  || VivirSeguro.porcentajeBeneficio2 === '') ? 0 : parseFloat(VivirSeguro.porcentajeBeneficio2);
                let pt = p1 + p2;
                console.log("🚀 ~ file: VivirSeguro.jsx ~ line 109 ~ validate ~ pt", pt)
                if(pt !== 100){
                    valid = false;
                    setMsg('El porcentaje de beneficio debe ser el 100%');
                }
;            }
         }

        return valid;
    }


    const create = () => {
        openModalSave();
        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source');
        const data = buildPoliza(VivirSeguro, src);
        return new Promise((resolve, reject) => {
            http(endPoints.createVivirSeguro).post(data).then(response => {
                setVivirSeguro({ ...VivirSeguro, guardado: true, numeroSolicitud: response.id });
                increment();
                closeModalSave();
            }).catch(error => {
            console.log("🚀 ~ file: VivirSeguro.jsx ~ line 92 ~ http ~ error", error)
                reject(error);
                setVivirSeguro({ ...VivirSeguro, guardado: false });
                closeModalSave();
                increment();
            });
        })
    }


    const getSumaAsegurada = () => {
        return new Promise(() => {
            http(endPoints.suminsuredbyplan(VivirSeguro.idPlan)).get().then(x => {
                let planEnabled = [];
                x.map((item) => {

                    if (item.text === "Plan: A" || item.text === "Plan: B" || item.text === "Plan: C")
                        planEnabled.push(item);
                })
                VivirSeguro.setCatalogos({ sumaAsegurada: planEnabled });
                console.log("🚀 ~ file: Step5.jsx ~ line 31 ~ http ~ planEnabled", VivirSeguro)
            });
        });
    }


    const getFees = () => {
        return new Promise(() => {
            http(endPoints.fees(VivirSeguro.idPlan)).getWithParam(`plan=${VivirSeguro.idPlan}`).then(x => {
                VivirSeguro.setCatalogos({ fees: x });
            });
        });
    };



    return (
        <div className="container">
            <div className="layout-vivirseguro">
                <div className="mt-10">
                    <p className="title-vs mb-10">
                        Con LAFISE ten&eacute;s la tranquilidad de Vivir Seguro
                    </p>
                    <p className="title5-vs mt-0 mb-10">
                        MicroSeguro de Vida “Vivir Seguro” autorizado seg&uacute;n resoluci&oacute;n SIB-OIF-XXVII-549-2019 del 08/08/2019
                    </p>
                </div>
                <IconProgressBar indexProgress={switchTypeIcon[index]} />
                <LineProgressBar indexProgress={switchTypeIcon[index]} />
                <form>
                    <Pages indexProgress={index} />
                    <ControlButton cssButton={cssControlButton(index)}>
                        {index !== 0 &&
                            <button tabindex="-1"
                                className={`control-button-btn-vivirseguro prev`}
                                type="button"
                                onClick={decrement}
                            >
                                Regresar
                             </button>
                        }
                        {
                            <button tabindex="-1"
                                className="control-button-btn-vivirseguro next"
                                type="button"
                                onClick={handleSubmit}
                            >
                                {textNext}
                                {index <= totalPages && <IconNext width={12} />}
                            </button>
                        }
                    </ControlButton>
                </form>
            </div>
            <Modal className="modal" isOpen={show} show={show} ariaHideApp={false}>
                <div className="dialog-center-content">
                    <p className="text-center">Guardando...</p>
                </div>
            </Modal>
            <Modal className="modal" isOpen={showMsg} show={showMsg} ariaHideApp={false}>
                <div className="modal-title">
                    <span className="txt-title-modal">Información</span>
                </div>
                <div className="modal-body-info">
                  {msg}
                </div>
                <div className="modal-footer">
                    <button className="modal-btn-close" onClick={closeModalMsg}>Cerrar</button>
                </div>
            </Modal>
        </div>
    );
}

export default VivirSeguro;